import { Dashboard } from "components";
import DashBoardHomeView from "./DashboardHomeView";

export const DashboardHomeContainer = () => {
  return (
    <Dashboard>
      <DashBoardHomeView />
    </Dashboard>
  );
};
